export enum CaredType {
  ELDER = 1,
  CHILD = 2,
  DISABLED = 3,
  HOSPITALIZED = 4,
  HOMECARE = 5,
}

export const Cared = {
  types: () => {
    return Object.keys(CaredType)
      .filter(k => typeof CaredType[k as any] === 'number')
      .map(cared => {
        return { value: CaredType[cared], label: cared }
      })
  },
}

export interface Cared {
  label: string
  value: string
}

export const caredText = {
  ELDER: 'Persona mayor',
  CHILD: 'Niño/a',
  DISABLED: 'Persona con discapacidad',
  HOSPITALIZED: 'Persona hospitalizada',
  HOMECARE: 'Servicio doméstico',
}

export const mapCaredToTagManager = cared => {
  switch (cared) {
    case 1:
      return 'Senior'
    case 2:
      return 'Kids'
    case 3:
      return 'Discapacidad'
    case 4:
      return 'Hospital'
    default:
      return undefined
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/cared/cared.ts